import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, OnInit, Input, Output, EventEmitter, ViewChild, ViewRef } from '@angular/core';

@Component({
	selector: 'category-nav',
	templateUrl: './category-nav.component.html',
	styleUrls: ['./category-nav.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CategoryNavComponent implements OnInit {
	@Input() itemsToHide;
	@Input() categories;
	@Input() comboCategoryName = 'Combos';
	@Input() pizzaCategoryName = 'Pizzas';
	@Input() stickyMode = false;

	@Input() isNewHomePedirDelivery = false;
	@Input() set activeCategoryValue(value: string) {
		this.markActive(value);
	}

	@ViewChild('pillsWrapper') pillsWrapper: ElementRef<HTMLElement>;

	categoryToScroll: string = '';
	categoryToCentralizeInNav: string;
	selectedCategory: any;
	selectId = 'categoryNav';

	@Output() scrollToCategory = new EventEmitter<string>();

	constructor(private cdr: ChangeDetectorRef) { }

	ngOnInit() {
		if (this.categoryToScroll) return;

		if (this.itemsToHide && !this.itemsToHide.featuredItems) { this.categoryToScroll = 'featuredItems'; return; }
		if (this.itemsToHide && !this.itemsToHide.combos) { this.categoryToScroll = 'combos'; return; }
		if (this.itemsToHide && !this.itemsToHide.pizzas) { this.categoryToScroll = 'pizzas'; return; }
		if (this.categories?.length) this.categoryToScroll = this.categories[0].name + '-' + this.categories[0].id;
	}

	/**
	 * Volta a marcar a categoria em que a página ESTÁ mesmo sem o input `activeCategoryValue`
	 * mudar — o caso da pill cancelada (`MenuPage.showCategoryInView`). A escolha pôs
	 * `categoryToScroll` na categoria pedida; o scrollspy continua com o mesmo valor e o setter
	 * não roda. Sem isto a pill cancelada seguia destacada, e o `<select>` ficava na opção
	 * cancelada — e escolher a mesma opção de novo não dispara `change`.
	 */
	showActive(value: string) {
		if (!this.markActive(value) || (this.cdr as ViewRef).destroyed) return;
		this.cdr.detectChanges();
	}

	/** Marca `value` como a categoria ativa; `false` se já era. */
	private markActive(value: string): boolean {
		if (value == null || value === '' || value === this.categoryToScroll) return false;
		this.categoryToScroll = value;
		setTimeout(() => this.scrollActivePillIntoView(), 50);
		return true;
	}

	selectCategory(value: string) {
		this.categoryToScroll = value;
		this.scrollToCategory.emit(value);
	}

	scrollActivePillIntoView() {
		if (this.stickyMode || !this.pillsWrapper?.nativeElement) return;
		const active = this.pillsWrapper.nativeElement.querySelector('.category-pill--active') as HTMLElement;
		if (active) active.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
	}

	onSelectChange(ev: Event) {
		const value = (ev.target as HTMLSelectElement).value;
		this.categoryToScroll = value;
		this.scrollToCategory.emit(value);
	}

	/**
	 * Toque num segmento do layout legado. O `ion-segment` só emite `ionChange` quando o valor
	 * MUDA, então tocar de novo na categoria já marcada não fazia nada — e é justamente o que
	 * a pessoa faz quando o primeiro toque parece não ter pegado (a categoria ainda montando)
	 * ou depois de ter rolado para longe dela. O `(click)` do botão roda antes do listener do
	 * segmento (o evento sobe do botão para o segmento), então aqui `categoryToScroll` ainda é
	 * o valor anterior: igual = toque repetido, emite; diferente = o `ionChange` emite.
	 */
	reselectSegment(value: string) {
		if (value === this.categoryToScroll) this.scrollToCategory.emit(value);
	}

	changeCategory(ev: any) {
		const value = ev?.detail?.value;
		if (value != null) {
			this.categoryToScroll = value;
			this.scrollToCategory.emit(value);
		}
	}

	trackById(_index: number, category: any) {
		return category ? category.id : _index;
	}

	truncate(text: string, maxLength = 35): string {
		const isMobile = window.innerWidth < 768;
		maxLength = isMobile ? 30 : 60;
		if (!text || text.length <= maxLength) return text;
		return text.slice(0, maxLength).replace(/\s+$/, '') + '…';
	}

	showCategory(items) {
		// if(category.isSelfService) return false;

		// const items = category.products;

		if(!items) return false;

		return items.some(item => !item.unavailable && !item.unavailableByTemplate && item.totalCalcType !== 'WEIGHT');
	}

}
